import { useQueryClient } from '@tanstack/react-query';

import type { ResultOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';

import { PORTFOLIOS_QUERY_KEY } from '../usePortfolio';
import { AGGREGATE_PORTFOLIO_QUERY_KEY } from '../useAggregatePortfolio';

import { makeGqlMutation } from '@/utilities/gqlQuery';
import { useSnackbar } from '@/features/snackbar';

const MUTATION = gql(`
  mutation createTransactionPortfolio($name: String) {
    createTransactionPortfolio(name: $name) {
      id
    }
  }
`);

const mutation = makeGqlMutation(MUTATION);

interface Props {
  onSuccess?: (data: ResultOf<typeof MUTATION>) => void;
}

export function useCreateTransactionPortfolio({ onSuccess }: Props = {}) {
  const queryClient = useQueryClient();
  const { addSnackbar } = useSnackbar();

  return mutation({
    onSuccess,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: PORTFOLIOS_QUERY_KEY });
      queryClient.invalidateQueries({
        queryKey: AGGREGATE_PORTFOLIO_QUERY_KEY,
      });
    },
    onError: () => {
      addSnackbar({
        message:
          'Failed to create transaction portfolio. Please try again later.',
        type: 'negative',
        lifeTime: 5000,
      });
    },
  });
}
